import { render, staticRenderFns } from "./NavMenuCategory.vue?vue&type=template&id=380ab0d6&scoped=true"
import script from "./NavMenuCategory.vue?vue&type=script&lang=js"
export * from "./NavMenuCategory.vue?vue&type=script&lang=js"
import style0 from "./NavMenuCategory.vue?vue&type=style&index=0&id=380ab0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ab0d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VMenu})
